class EmployeePhotoStrip extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this._images = [];
    this._backgroundColor = 'transparent';
    this.scrollDistance = 0;
  }

  static get observedAttributes() {
    return ['background-color', 'images'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'background-color') {
      this._backgroundColor = newValue;
      this._updateStyles();
    }
    if (name === 'images') {
      try {
        this._images = JSON.parse(newValue.replace(/&quot;/g, '"'));
        this._render();
      } catch (e) {
        console.warn('Failed to parse images attribute:', e);
        this._images = newValue.split(',');
      }
    }
  }

  connectedCallback() {
    const imagesAttr = this.getAttribute('images');
    if (imagesAttr) {
      try {
        this._images = JSON.parse(imagesAttr.replace(/&quot;/g, '"'));
      } catch (e) {
        console.error('Failed to parse initial images attribute:', e);
      }
    }
    this._render();
  }

  _render() {
    const style = `
      :host {
        display: block;
        aspect-ratio: 280 / 447;
        width: 100%;
      }

      .container {
        width: 100%;
        height: 100%;
        background-color: ${this._backgroundColor};
        overflow: hidden;
        position: relative;
        box-sizing: border-box;
      }

      .scroll-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        gap: 16px;
        transition: transform 0.6s cubic-bezier(0.4, 0.0, 0.2, 1);
        transition-duration: 1.8s;
      }

      .scroll-container.scrolling {
        /*transform: translateY(-${this.scrollDistance}px);*/
      }

      img {
        width: 100%;
        flex-shrink: 0;
        object-fit: cover;
        display: block;
      }
      
      @media (max-width: 768px) {
        .container {
          padding: 8px;
        }

        .scroll-container {
          gap: 8px;
        }
      }
    `;

    this.shadowRoot.innerHTML = `
      <style>${style}</style>
      <div class="container">
        <div class="scroll-container" id="scrollContainer">
          ${this._images.map(url => `
            <img src="${url}" alt="Employee photo" loading="eager">
          `).join('')}
        </div>
      </div>
    `;

    const scrollContainer = this.shadowRoot.getElementById('scrollContainer');
    const mainContainer = this.shadowRoot.querySelector('.container');

    scrollContainer.addEventListener('mouseenter', () => {
      this.scrollDistance = scrollContainer.scrollHeight - mainContainer.clientHeight;
      if (window.innerWidth <= 768) {
        this.scrollDistance = scrollContainer.scrollHeight - mainContainer.clientHeight;
      }
      scrollContainer.style.transform = `translateY(-${this.scrollDistance}px)`
    });

    scrollContainer.addEventListener('mouseleave', () => {
      scrollContainer.style.transform = 'translateY(0)';
    });
  }

  _updateStyles() {
    const container = this.shadowRoot.querySelector('.container');
    if (container) {
      container.style.backgroundColor = this._backgroundColor;
    }
  }
}

customElements.define('employee-photo-strip', EmployeePhotoStrip);